import { HomepageModel } from './homepage'
import { SearchResultModel } from './searchResult'
import { AdDetailModel } from './adDetail'
import { adDeactivatedSoldModel } from './adDeactivatedSold'
import { FavoritesListModel } from './favoritesList'
import { RepechageModel } from './repechage'
import { videoCallSchedulingModel } from './videoCallScheduling'
import { videoCallSchedulingSuccessModel } from './videoCallSchedulingSuccess'
import { FinancingModel } from './financing'

const DATALAYER_PAGES = {
  homepage: 'homepage',
  searchResult: 'searchResult',
  adDetail: 'adDetail',
  repechage: 'repechage',
  favoritesList: 'favoritesList',
  videoCallScheduling: 'videoCallScheduling',
  videoCallSchedulingSuccess: 'videoCallSchedulingSuccess',
  comparator: 'comparator',
  adDeactivatedSold: 'adDeactivatedSold',
  financing: 'financing',
}

const DATALAYER_MODELS = {
  ...HomepageModel,
  ...SearchResultModel,
  ...AdDetailModel,
  ...adDeactivatedSoldModel,
  ...FavoritesListModel,
  ...RepechageModel,
  ...videoCallSchedulingModel,
  ...videoCallSchedulingSuccessModel,
  ...FinancingModel,
}

export { DATALAYER_MODELS, DATALAYER_PAGES }
